__webpack_require__.p = "/wp-content/themes/pratt/dist/";